import { Link } from "react-router-dom";
import { useSite, DEFAULT_LOGO, DEFAULT_LOGO_WIDE } from "@/lib/site";

export const BrandLogo = ({ size = "md", to = "/", testId = "brand-logo" }) => {
  const site = useSite();
  const custom = !!site.logo;
  const h = size === "lg" ? "h-24" : size === "sm" ? "h-14" : "h-16 sm:h-[4.75rem]";
  return (
    <Link to={to} className="flex items-center gap-3 min-w-0" data-testid={testId} aria-label="Motley Mentors home">
      <img src={custom ? site.logo : DEFAULT_LOGO_WIDE} alt="Motley Mentors"
        className={`${h} w-auto max-w-[240px] rounded-2xl object-contain shrink-0 shadow-md ring-1 ring-black/5`} />
      {custom && (
        <span className={`font-heading font-extrabold tracking-tight truncate text-slate-900 ${size === "lg" ? "text-3xl" : size === "sm" ? "text-lg" : "text-xl sm:text-2xl"}`}>
          motley<span className="text-primary">mentors</span>
        </span>
      )}
    </Link>
  );
};

export { DEFAULT_LOGO };

export const SiteFooter = () => (
  <footer className="border-t border-slate-200 bg-white">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-10 grid gap-8 md:grid-cols-[1.4fr_1fr_1fr]">
      <div>
        <BrandLogo size="sm" testId="footer-logo" />
        <p className="font-body text-sm text-slate-500 mt-3 max-w-sm">Lighting up lives with mentoring. Mentors who've walked the path, plus AI-enabled career assessments to give you the extra edge.</p>
      </div>
      <div>
        <p className="font-heading font-bold text-sm text-slate-900 mb-3">Explore</p>
        <ul className="space-y-2 font-body text-sm text-slate-500">
          <li><Link to="/mentors" className="hover:text-primary" data-testid="footer-mentors-link">Find a mentor</Link></li>
          <li><Link to="/assessments" className="hover:text-primary" data-testid="footer-assessments-link">Career assessments</Link></li>
          <li><Link to="/contact?interest=mentor" className="hover:text-primary" data-testid="footer-become-mentor-link">Become a mentor</Link></li>
          <li><Link to="/contact" className="hover:text-primary" data-testid="footer-contact-link">Contact us</Link></li>
          <li><a href="mailto:info@motleymentors.com" className="hover:text-primary" data-testid="footer-email-link">info@motleymentors.com</a></li>
        </ul>
      </div>
      <div>
        <p className="font-heading font-bold text-sm text-slate-900 mb-3">Access</p>
        <ul className="space-y-2 font-body text-sm text-slate-500">
          <li><Link to="/access" className="hover:text-primary" data-testid="footer-access-link">Enter assessment code</Link></li>
          <li><Link to="/admin-login" className="hover:text-primary" data-testid="admin-login-link">Admin & partner sign in</Link></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-slate-100 py-4 text-center font-body text-xs text-slate-400">© {new Date().getFullYear()} Motley Mentors · CareerCompass</div>
  </footer>
);
